
import React, { useState } from "react";
import JobCard     from "./JobCard";

export default function JobGridSearch({ jobs, onSend, onOpenPremiumModal }) {
  const [selected, setSelected]       = useState(null);
  return (
    <div className="flex flex-1 flex-col h-full items-center overflow-y-auto w-full overflow-x-hidden gap-2 md:px-10 mt-4 no-scrollbar">
      <div className="mb-4 flex gap-2 flex-col">
        {jobs.map(job => (
          <JobCard key={job.objectID} onOpenPremiumModal={onOpenPremiumModal} job={job} selected={selected} setSelected={setSelected} onSend={onSend} overlay={'search'} />
        ))}
      </div>
    </div>
  );
}